const carouselItems = [
  {
    title: '某顶流男星年度大瓜全梳理',
    desc: '从年初的疑似恋情到年中的合约纠纷，梳理这位顶流男星一整年的热点事件时间线，完整还原每一个高能瞬间。',
    tag: '年度盘点',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20spotlight%20illustration%20with%20dramatic%20lighting%20and%20silhouette%20figure%2C%20warm%20coral%20and%20amber%20gradients%2C%20editorial%20flat%20vector%20style%2C%20timeline%20concept%20with%20floating%20newspaper%20elements%2C%20modern%20magazine%20cover%20aesthetic&width=800&height=480&seq=carousel-01&orientation=landscape',
  },
  {
    title: '综艺圈年度十佳名场面',
    desc: '回顾本年度最令人难忘的综艺高光时刻，从即兴表演到真情流露，每一帧都是经典中的经典。',
    tag: '综艺回顾',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20highlight%20illustration%20with%20colorful%20confetti%20and%20spotlight%20effects%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20editorial%20flat%20vector%20style%2C%20celebration%20atmosphere%2C%20TV%20studio%20vibe%2C%20modern%20clean%20design&width=800&height=480&seq=carousel-02&orientation=landscape',
  },
  {
    title: '网红圈年度纠纷始末深度解读',
    desc: '今年网红圈最轰动的几场争端，从起因到发酵再到各方回应，带你完整了解每一个事件的来龙去脉。',
    tag: '深度吃瓜',
    img: 'https://readdy.ai/api/search-image?query=Social%20media%20drama%20illustration%20with%20speech%20bubbles%20and%20broken%20connections%2C%20warm%20coral%20gradient%20tones%2C%20editorial%20flat%20vector%20style%2C%20digital%20conflict%20concept%2C%20modern%20internet%20culture%20aesthetic%2C%20clean%20composition&width=800&height=480&seq=carousel-03&orientation=landscape',
  },
  {
    title: '影视圈口碑逆袭黑马作品盘点',
    desc: '那些开播时无人问津、结尾时惊艳所有人的黑马剧集，看看它们凭什么能实现口碑与热度的双重逆袭。',
    tag: '影视盘点',
    img: 'https://readdy.ai/api/search-image?query=Film%20and%20television%20success%20illustration%20with%20rising%20graph%20and%20golden%20trophy%2C%20warm%20amber%20lighting%2C%20editorial%20flat%20vector%20style%2C%20achievement%20and%20breakthrough%20concept%2C%20cinematic%20elegance%2C%20modern%20sophisticated%20design&width=800&height=480&seq=carousel-04&orientation=landscape',
  },
  {
    title: '乐坛新生代歌手群像全解读',
    desc: '从选秀舞台走向万人演唱会，盘点今年最值得关注的音乐新生力量，谁将成为下一个天王天后？',
    tag: '音乐观察',
    img: 'https://readdy.ai/api/search-image?query=Music%20new%20generation%20illustration%20with%20concert%20stage%20and%20rising%20stars%2C%20warm%20coral%20and%20amber%20gradients%2C%20editorial%20flat%20vector%20style%2C%20energetic%20youthful%20atmosphere%2C%20modern%20pop%20culture%20aesthetic%2C%20clean%20dynamic%20composition&width=800&height=480&seq=carousel-05&orientation=landscape',
  },
  {
    title: '年度最受关注品牌代言风云录',
    desc: '从奢侈大牌到国民快消，品牌代言人变更背后的商业逻辑与粉丝经济的深度博弈。',
    tag: '商业分析',
    img: 'https://readdy.ai/api/search-image?query=Brand%20endorsement%20illustration%20with%20luxury%20products%20and%20elegant%20display%2C%20warm%20amber%20and%20coral%20tones%2C%20editorial%20flat%20vector%20style%2C%20premium%20commercial%20photography%20vibe%2C%20sophisticated%20and%20modern%2C%20clean%20composition&width=800&height=480&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          本周焦点深扒
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">深度聚焦当前最值得关注的娱乐大事件</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all flex flex-col"
            >
              <div className="relative w-full aspect-[5/3] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-semibold text-foreground-900 text-base leading-snug">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="mt-4 pt-4 border-t border-background-200/50 flex items-center text-xs text-foreground-400">
                  <span>深度阅读 · {8 + i * 3}分钟</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}